<template>
    <div>
        <translate tag="p" path="Cancellation.initial.text">
            <template v-slot:buttonText>
                {{buttonText}}
            </template>
        </translate>

        <div class="form-group form-row align-items-center justify-content-md-center">
            <div class="col-xs-12 col-sm-9 col-md-6">
                <input type="text" :value="code" @change="$emit('update:code', $event.target.value)"
                       minlength="5"
                       class="form-control input-gray"
                       :placeholder="$t('Cancellation.code.placeholder') + ' (GA-…)'"
                       required autofocus
                       :aria-label="$t('Cancellation.code.placeholder') + ' (GA-…)'"
                />
            </div>

            <div class="col-xs-12 col-sm-3 col-md-auto text-center text-sm-left">
                <button class="btn btn-primary btn-lg mt-3 mt-sm-0" type="submit" name="init">
                    {{buttonText}}
                </button>
            </div>
        </div>

        <p class="warning-text">
          {{$t('Cancellation.initial.warning')}}
        </p>

    </div>
</template>

<script>
    export default {
        name: 'CancellationInitForm',
        props: {
            code: {
                type: String,
                required: true
            }
        },
        computed: {
            buttonText() {
                return `${this.$t('Generic.further')} >`;
            }
        }
    }
</script>

<style scoped>
p.warning-text {
  margin-top: 20px;
  padding: 20px;
  border: 2px solid #ff8833;
}
</style>
